import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-29eaca97"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "CategoryTaobao" }
const _hoisted_2 = { class: "CategoryTaobao-title" }
const _hoisted_3 = { class: "CategoryTaobao-list" }
const _hoisted_4 = ["href"]
const _hoisted_5 = {
  key: 0,
  class: "CategoryTaobao-list-column-separator"
}

import { t } from '@/plugins/i18n'
import { cTaobao } from '@/assets/js/platform/category'

import { Site } from '@/common/const'
import { useSite2Station } from '@/store'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const stationCode = useSite2Station()


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)(_unref(cTaobao).title)), 1),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cTaobao).row, (row, rowIndex) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "CategoryTaobao-list-row",
          key: rowIndex
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.column, (column, columnIndex) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "CategoryTaobao-list-column",
              key: columnIndex
            }, [
              _createElementVNode("a", {
                class: "CategoryTaobao-list-column-name",
                href: column.url,
                target: "_blank"
              }, _toDisplayString(_unref(stationCode)=== _unref(Site).JA ? column.name_ja : _unref(t)(column.name)), 9, _hoisted_4),
              (columnIndex !== row.column.length-1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, "/"))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      }), 128))
    ])
  ]))
}
}

})